
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import ClinicLogo from '../../assets/SVG/img_logo_svg.svg';
import { useVerboseLog } from '../../utils/debug';
interface TreatmentPlanDrugProps {
  data: any;
  iframeRef?: React.RefObject<HTMLIFrameElement>;
}

const TreatmentPlanDrug: React.FC<TreatmentPlanDrugProps> = ({
  data,
  iframeRef,
}) => {
  const verboseLog = useVerboseLog();

  verboseLog('data', data);


  const html = `<!DOCTYPE html>
        <html>
        <head>
        <meta charset="UTF-8">
        <style>
            body {
            font-family: Arial, sans-serif;
            padding: 40px;
            width: 794px;
            height: 1123px;
            }

            section {
            margin-bottom: 20px;
            }

            table {
            border-collapse: collapse;
            width: 100%;
            margin-top: 10px;
            }

            th, td {
            border: 1px solid #000;
            padding: 4px;
            text-align: left;
            }

            th {
            background-color: #f0f0f0;
            }

            .no-border th,
            .no-border td,
            .no-border thead,
            .no-border tbody {
            border: none !important;
            }

            .center {
            text-align: center !important;
            }

            @media print {
                .page-break {
                    break-before: page;
                }
            }

            .padded {
            padding: 16px 0 !important;
            }

            .top-margin {
            margin-top: 8px;
            }

            .header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              border-bottom: 2px solid #ccc;
              padding-bottom: 20px;
            }

            .header .info {
              background-color: #E1E1E1;
              max-width: 60%;
              border-radius: 12px;
              padding: 16px;
            }

            .header h1 {
              margin: 0;
              font-size: 28px;
            }

            .header p {
              margin: 4px 0;
              font-size: 14px;
            }

            .header .logo {
              max-width: 288px;
            }

            .lineSpacing{
              line-height: 1.5;
              padding: 1px 0;
            }
            .patient-partner-details {
              margin-bottom: 20px;
              padding-bottom: 20px;
              border-bottom: 2px solid #ccc;
            }
            .end_report {
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              align-items: center;
              padding-top: 24px;
            }
        </style>
        </head>

        <body>
        <div class="header">
          <div class="info">
            <h1>PureCare Clinic</h1>
            <p class="lineSpacing"></p>
              756 University Avenue, Lake Jeniferberg 35967, 46913 Farrell Burg,
              Treutelstad 64243
            </p>
            <p class="lineSpacing"><strong>Email</strong>: ramon_morissette54@gmail.com</p>
            <p class="lineSpacing"><strong>Mob</strong>: 578-778-3291 / 578-778-3291</p>
            <p class="lineSpacing"><strong>Website</strong>: purecareclinic.com</p>
          </div>
          <div class="logo">
            <img
              src=${ClinicLogo}
              alt="Logo"
              width="196px"
            />
          </div>
        </div>
        
        <div style="font-family: Arial, sans-serif; max-width: 800px;">
            <h3>Treatment Plan - Drug Details</h3>

            ${data.map((item : any, index:number) => {
    const date = new Date(item.created_on);
    const formattedDate = `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth()+1).padStart(2, '0')}/${date.getFullYear()}`;
    return `
                <div style="border: 1px solid #ccc; border-radius: 8px; padding: 12px; margin-bottom: 20px; box-shadow: 0 2px 8px rgba(0,0,0,0.05);" class=${index !==0 && index % 2 === 0 ? 'page-break' : ''}>
                    <p><strong>Doctor Name:</strong> ${item.user_first_name ?? ''}</p>
                    <p><strong>Drug Name:</strong> ${item.drug?.name ?? ''}</p>
                    <p><strong>Date:</strong> ${formattedDate}</p>
                    <p><strong>Instructions:</strong> ${item.instructions?.split('_').join(' ').toLocaleUpperCase() ?? ''}</p>
                    <p><strong>Frequency:</strong> ${item.frequency ?? ''}</p>
                    <p><strong>Default Route:</strong> ${item.default_drug_route_code ?? item.drug_route_code ?? ''}</p>
                    <p><strong>Notes:</strong> ${item.notes ?? ''}</p>

                    <table style="width: 100%; border-collapse: collapse; margin-top: 10px;">
                    <thead>
                        <tr style="background: #f0f0f0;">
                        <th style="border: 1px solid #ccc; padding: 8px;">Molecule</th>
                        <th style="border: 1px solid #ccc; padding: 8px;">Strength</th>
                        <th style="border: 1px solid #ccc; padding: 8px;">UOM</th>
                        <th style="border: 1px solid #ccc; padding: 8px;">Quantity</th>
                        <th style="border: 1px solid #ccc; padding: 8px;">No. of Days</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td style="border: 1px solid #ccc; padding: 8px;">${item.drug?.molecule ?? ''}</td>
                        <td style="border: 1px solid #ccc; padding: 8px;">${item.drug?.strength ?? ''}</td>
                        <td style="border: 1px solid #ccc; padding: 8px;">${item.drug?.stock_uom_code ?? ''}</td>
                        <td style="border: 1px solid #ccc; padding: 8px;">${item.quantity ?? ''}</td>
                        <td style="border: 1px solid #ccc; padding: 8px;">${item.no_of_days ?? ''}</td>
                        </tr>
                    </tbody>
                    </table>
                </div>
                `;
  }).join('')}
            </div>


        </section>
        <footer>
            <div class="end_report">
              <strong>End of Report</strong>
              <p>Note: This report is generated for informational purposes only and should not be considered as a medical advice.</p>            
            </div>        
        </footer>
        </body>
        </html>`;
  return (
    data && (
      <iframe
        title="treatmentPlanDrug"
        width="100%"
        height="100%"
        style={{ border: 'none', overflow: 'hidden' }}
        srcDoc={html}
        ref={iframeRef} // Attach the ref to the iframe
      />
    )
  );
};

export default TreatmentPlanDrug;
